import AppAuthLogo from '../assests/Logo.png'
import AppeyeClose from '../assests/eyeClose.png'
import AppeyeOpen from '../assests/eyeOpen.png'
import AppCheck from '../assests/check.png'
import AppLogout from '../assests/logoutArrow.png'
import AppUP from '../assests/upArrow.png'
import AppSearch from '../assests/search.png'
import AppDashBoard from '../assests/dashboard.png'
import AppBDashBoard from '../assests/Bdashboard.png'
import AppFaq from '../assests/faq.png'
import AppBFaq from '../assests/Bfaq.png'
import AppPrivacyPolicy from '../assests/PrivacyPolicy.png'
import AppBPrivacyPolicy from '../assests/BPrivacyPolicy.png'
import AppTermsofServices from '../assests/TermsofServices.png'
import AppBTermsofServices from '../assests/BTermsofServices.png'
import AppUsers from '../assests/Users.png'
import AppBUsers from '../assests/BUsers.png'
import AppTotalUser from '../assests/Totaluser.png'
import AppCal from '../assests/calender.png'
import Appref from '../assests/Ref.png'
import UsPic from '../assests/UserPic.png'
import AppBin from '../assests/Bin.png'
import Apponboard1 from '../assests/onboard1.png'
import Apponboard2 from '../assests/onboard2.png'
import Apponboard3 from '../assests/onboard3.png'
import AppFaqArr from '../assests/faqArrow.png'
import AppFaqArr2 from '../assests/faqArrow2.png'
import AppfaqBlo from '../assests/faqBlock.png'
import AppfaqBlo2 from '../assests/faqBlock2.png'
import AppBurger from '../assests/burger.png'

export const StaticImages = {


    Menu:{
        Icon:AppBurger,
    },
    
    Arr: {
        UpBlock:AppfaqBlo,
        DownBlock:AppfaqBlo2,
        Up: AppFaqArr,
        Down: AppFaqArr2
    },

    OnBo: {
        Icon1: Apponboard1,
        Icon2: Apponboard2,
        Icon3: Apponboard3
    },
    DeleteBin: {
        Icon: AppBin,
    },
    UserPi: {
        Icon: UsPic,
    },
    Refresh: {
        Icon: Appref,
    },
    TotalUse: {
        Icon: AppTotalUser,
    },
    Cale: {
        Icon: AppCal,
    },
    Dash_Board: {
        WIcon: AppDashBoard,
        Icon: AppBDashBoard,
    },
    User: {
        WIcon: AppUsers,
        Icon: AppBUsers,
    },
    FAQ: {
        WIcon: AppFaq,
        Icon: AppBFaq,
    },
    PrivacyPol: {
        WIcon: AppPrivacyPolicy,
        Icon: AppBPrivacyPolicy,
    },
    Terms: {
        WIcon: AppTermsofServices,
        Icon: AppBTermsofServices,
    },
    AuthLogo: {
        Icon: AppAuthLogo,
    },
    Eye: {
        openIcon: AppeyeOpen,
        closeIcon: AppeyeClose
    },
    RCheck: {
        Icon: AppCheck,

    },
    Arrow: {
        Logout: AppLogout,
        UP: AppUP,
        Search: AppSearch
    }

}